<div class="ui basic segment" [class.loading]="isLoading">
    <div *ngIf="missingTemplates" class="ui segment">
        <app-header title="performance.review-store.missingTemplates.title" [back]="true"></app-header>
        <div class="ui divider"></div>
        <p>{{ 'performance.review-store.missingTemplates.description' | translate }}</p>
    </div>

    <app-steps
        #appSteps
        *ngIf="!missingTemplates"
        [steps]="[detailsStep, templateStep, participantsStep, summaryStep]"
        action="Create"
        (onPrimary)="onSave()"
        (onNext)="onNextStep($event)"
        (onPrevious)="onPreviousStep($event)"
    >
        <app-step
            #detailsStep
            [stepForm]="detailsForm"
            step="performance.review-store.detailsStep.stepLabel"
            title="performance.review-store.detailsStep.title"
        >
            <app-form-review-details
                #detailsForm
                [review]="review"
                (subjectChanged)="participantsForm.ngOnInit()"
            ></app-form-review-details>
        </app-step>

        <app-step #templateStep [stepForm]="templateForm" step="Template" title="Choose a template">
            <app-form-review-template #templateForm [review]="review"></app-form-review-template>
        </app-step>

        <app-step #participantsStep [stepForm]="participantsForm" step="Participants" title="Select participants">
            <app-form-review-participants
                #participantsForm
                [review]="review"
                [participants]="participants"
            ></app-form-review-participants>
        </app-step>

        <app-step #summaryStep [stepForm]="summaryForm" step="Summary" title="Summary and send">
            <app-form-review-summary
                #summaryForm
                [review]="review"
                [participants]="participants"
            ></app-form-review-summary>
        </app-step>
    </app-steps>
</div>
